import { Group, Text } from "@mantine/core";
import { IconArrowDownRight, IconArrowUpRight, IconMinus } from "@tabler/icons-react";

interface Props {
  /** Period-over-period change, percent. `null` = no comparable baseline. */
  deltaPct: number | null;
  suffix?: string;
}

// Trend signal that never relies on color alone: a direction arrow + signed
// number carry the meaning, color reinforces it, and an aria-label spells it out.
export function TrendBadge({ deltaPct, suffix }: Props) {
  if (deltaPct === null || Number.isNaN(deltaPct)) {
    return <Text span size="xs" c="dimmed">шинэ</Text>;
  }
  const flat = deltaPct === 0;
  const up = deltaPct > 0;
  const color = flat ? "gray" : up ? "green" : "red";
  const Icon = flat ? IconMinus : up ? IconArrowUpRight : IconArrowDownRight;
  const a11y = `${up ? "өссөн" : flat ? "өөрчлөлтгүй" : "буурсан"} ${Math.abs(deltaPct)} хувь`;
  return (
    <Group component="span" gap={2} wrap="nowrap" aria-label={a11y}>
      <Icon size={14} aria-hidden color={`var(--mantine-color-${color}-6)`} />
      <Text span size="xs" fw={600} c={flat ? "dimmed" : color}>
        {Math.abs(deltaPct)}%{suffix ? ` ${suffix}` : ""}
      </Text>
    </Group>
  );
}
